<script>
import { defineComponent, getCurrentInstance, nextTick, onBeforeUnmount } from 'vue';
import { useMarketingFilters } from '../composables/useMarketingFilters';

export default defineComponent({
  name: 'PageFilters',
  setup(_, { slots }) {
    const { setPageFilterSlot } = useMarketingFilters();
    const owner = getCurrentInstance();
    let active = true;

    onBeforeUnmount(() => {
      active = false;
      setPageFilterSlot(null, owner);
    });

    return () => {
      const slot = slots.default || null;
      nextTick(() => {
        if (active) setPageFilterSlot(slot, owner);
      });
      return null;
    };
  }
});
</script>
